export const env = {

    "API_URL": "https://api.staging.bitonsoccer.com",
    "APP_URL": "https://bitonsoccer.com",
    "NETWORK": "TESTNET"
}

export default env
